export const CONFIG_ENV_JSON_PATH = '/config/env.json';
